export default "__VITE_ASSET__tkvb51e0__"